import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS
} from '../../../constants/general';
import { fetchProviders } from '../../../store/actions/providerActions';

class SearchProvider extends Component {

	constructor(props) {
		super(props);
	    this.state = {
			isLoading:false,
			providers: [],
		}
	}

	SearchAction(query) {
		if (!query || query.trim() === '') {
			this.setState({ providers: [], isLoading: false });
			return;
		}

		let { userHigherAccess, type } = this.props;
		if (userHigherAccess > BRANCH_ACCESS) {
			this.setState({ isLoading: true });
			//!INFO: por ahroa se maneja nada mas el caso especifico de shopper
			this.props.fetchProviders(1, `name=ilike ${query}${type === 'shopper' ? '&is_shopper=1' : ''}`)
				.then(() => {
					let newList = [];
					if (this.props.providers && this.props.providers.data && this.props.providers.data.length > 0) {
						newList = this.props.providers.data.map(b => { return { access_id: b.id, related_access: b } });
					}
					this.setState({ providers: newList, isLoading: false });
				})
				.catch(() => {
					this.setState({ isLoading: false });
				});
		}
	}

	handleClear = () => {
		this.props.change("")
		this._typeahead.getInstance().clear()
	}

	render () {
		return (
            <div className="d-flex">
				{this.props.fromReports && (
					<div 
						className={`custon_tap custon_active_tab`} 
						onClick={()=> this.handleClear()} 
						style={{padding: `0 5px 0 0`,display:'flex', gap:'10px',alignItems: 'center',cursor:"pointer"}}
					>
						<span className='mx-2'>
							Todos
						</span>
					</div>
				)}
				<div className='w-100'>
					<AsyncTypeahead
						ref={(ref) => (this._typeahead = ref)}
						labelKey="name"
						options={this.state.providers.map(
							($0) => $0.related_access
						)}
						filterBy={() => true}
						useCache={false}
						onChange={this.props.change}
						onSearch={(query) => this.SearchAction(query)}
						onInputChange={(text) => {
							if (!text || text.trim() === '') {
								this.setState({ providers: [] });
							}
						}}
						isLoading={this.state.isLoading}
						placeholder={"Buscar rider"}
						renderMenuItemChildren={(option, props, index) => (
							<div
								className="normaltext-autocomplete"
								style={{ display: `flex`, gap: `10px` }}
							>
								<img
									className="avatar_small"
									src={option && option.avatar_url}
									ref={`avatar_url`}
									onError={() =>
										(this.refs[`avatar_url`].src =
											"https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png")
									}
									alt={option.name}
								/>
								<div style={{ width: `calc(100% - 40px)` }}>
									{option.name}
									<br />
									<small>{option.email}</small>
								</div>
							</div>
						)}
					/>
				</div>
            </div>
        );
	}
}


const mapStateToProps = (state) => {
	return {
		userHigherAccess: state.userHigherAccess,
		providers:state.providers
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProviders: (page,query) => dispatch(fetchProviders(page,query)),
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchProvider);



// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchProvider.js